export default __webpack_public_path__ + "static/media/next.42c956b0.svg";